// extracted by mini-css-extract-plugin
export var cardBlogPost = "style-module--cardBlogPost--317a9";
export var copy = "style-module--copy--d5e3c";
export var media = "style-module--media--c8434";
export var subline = "style-module--subline--d5987";